export const compatibilites = {
    store: {
        // format of store
        v1: {}
    },
    url: {
        // url format and store format
        v1: {
            store: ['v1']
        }
    },
    cookies: {
        // cookies format and store format
        v1: {
            store: ['v1']
        }
    },
    server: {
        // server contract
        v1: {
            store: ['v1'],
            cookies: ['v1']
        }
    },
    api: {
        // api exposed to components
        v1: {
            store: ['v1'],
            server: ['v1'],
            url: ['v1'],
            cookies: ['v1']
        }
    }
}

export const apiCompatibilityGroups = {
    g1: ['v1']
}

export default apiCompatibilityGroups
